export default __webpack_public_path__ + "static/media/chevron.d943718f.svg";